import * as React from "react"
import { ProductAmountProps } from "./types"
import { Flex } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"

const _ProductAmount: React.FC<ProductAmountProps> = ({
  isBigBadge,
  isSmallMainScreen,
  price,
  oldPrice,
  isTransperent,
  quantity,
  currencySymbol
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)

  return (
    <Flex me={"0.3rem"} alignItems="end">
      {/* {price && ( */}
      <Flex
        fontSize={isSmallMainScreen || isBigBadge ? "xs" : "sm"}
        fontWeight={"medium"}
        display="inline"
        textOverflow="ellipsis"
        overflow="hidden"
        whiteSpace="nowrap"
        color={
          isTransperent
            ? "white"
            : roomStyles?.badgeTextColor && roomStyles?.badgeTextColor
        }
        visibility={price ? "visible" : "hidden"}
      >
        {price ? currencySymbol + (+price * quantity).toFixed(2) : "-"}
      </Flex>
      {/* )} */}
      {oldPrice && (
        <Flex
          fontSize={isSmallMainScreen || isBigBadge ? "xs" : "sm"}
          fontWeight={"medium"}
          textDecoration={"line-through"}
          marginLeft="0.6rem"
          color={
            isTransperent
              ? "white"
              : roomStyles?.badgeTextColor && roomStyles?.badgeTextColor
          }
          display="inline"
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap"
          opacity="0.65"
        >
          {currencySymbol + (+oldPrice * quantity).toFixed(2)}
        </Flex>
      )}
    </Flex>
  )
}

export const ProductAmount = React.memo(_ProductAmount)
